/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
document.addEventListener("DOMContentLoaded", function(event) {
    activarNoticiasControls();
    activarDragLayer();
});

function calcularCurrent(){

    $posts = document.querySelector('.bloque-noticias .posts');
    const style= getComputedStyle($posts);
    const itemRightpadding = parseInt(style.paddingRight);

    document.totalPosts = document.querySelectorAll('.bloque-noticias .post');
    document.posNotis = [];

    if(document.totalPosts.length > 0){
        //document.totalPosts = document.totalPosts.length;
        $posicion = itemRightpadding;
        for (let $p = 0; $p < document.totalPosts.length; $p++) {
            if($p>0){
                $post = document.totalPosts[$p];
                $posicion += $post.offsetWidth;
            }
            document.posNotis[$p] = $posicion;
        }

        $posts.addEventListener('scroll', function(ev){
            $current = 0;
            if(document.posNotis.length>0){
                for (let $i = 0; $i < document.posNotis.length; $i++) {
                    if(this.scrollLeft>=document.posNotis[$i]){
                        $current = $i;
                    }
                }
                document.currentPost = $current;
                this.closest('.bloque-noticias').querySelector('.controls .current').innerHTML = ($current + 1);
            }
        })
    }

}


function activarNoticiasControls(){
    document.currentPost = 0;
    document.totalPosts = document.querySelectorAll('.bloque-noticias .post');
    if(document.totalPosts.length > 0){
        document.totalPosts = document.totalPosts.length;

        calcularCurrent();

        // next
        let $nextControl = document.querySelector('.bloque-noticias .controls .next');
        if($nextControl){
            $nextControl.addEventListener('click', function(){
                // console.log('nextControlclick');
                
                if(document.posNotis.length > 0 ){
                    document.currentPost++;
                    if(document.currentPost >= document.posNotis.length){
                        document.currentPost--
                    }else{
                        $posts.scrollLeft = document.posNotis[document.currentPost];
                    }

                }

            });
                
            // }
        }

        // prev
        let $prevControl = document.querySelector('.bloque-noticias .controls .prev');
        if($prevControl){
            $prevControl.addEventListener('click', function(){
                console.log('prevControl click');

                if(document.posNotis.length > 0 ){
                    document.currentPost--;
                    if(document.currentPost <= 0){
                        document.currentPost = 0;
                    }
                    $posts.scrollLeft = document.posNotis[document.currentPost];

                }

            });
        }    
        
        window.slider = document.querySelector('.bloque-noticias .posts-overflow');
        window.slider.addEventListener('scroll', function(e){
            // console.log(this.scrollLeft);
            // console.log(document.currentPost);
        });

    }
}

let mouseDown = false;
let startX, scrollLeft;


function activarDragLayer(){
    window.slider = document.querySelector('.bloque-noticias .posts-overflow');

    const startDragging = (e) => {
        // console.log('startDragging');
        mouseDown = true;
        window.slider.style.scrollBehavior = 'unset';
        startX = e.pageX - window.slider.offsetLeft;
        scrollLeft = window.slider.scrollLeft;
        
    }

    const stopDragging = (e) => {
        // console.log('stopDragging');
        mouseDown = false;
        window.slider.style.scrollBehavior = 'smooth';
    }

    const move = (e) => {
        e.preventDefault();
        if(!mouseDown) { 
            return; 
        }
        const x = e.pageX - window.slider.offsetLeft;
        const scroll = x - startX;
        window.slider.scrollLeft = scrollLeft - scroll;
    }

    // Add the event listeners
    window.slider.addEventListener('mousemove', move, false);
    window.slider.addEventListener('mousedown', startDragging, false);
    window.slider.addEventListener('mouseup', stopDragging, false);
    window.slider.addEventListener('mouseleave', stopDragging, false);
}